import React, { ReactElement } from "react";
import { useSelector } from "react-redux";

import { selectCurrentLanguage } from "../flowEditorSlice";
import TranslateIcon from "./TranslateIcon";
import styles from "./TranslationEditor.module.css";

export default function TranslationEditor({
  language,
  children,
}: {
  language?: string | null;
  children: (language: string) => JSX.Element;
}): ReactElement | null {
  const globalLanguage = useSelector(selectCurrentLanguage);
  const effectiveLanguage = language ?? globalLanguage;

  if (effectiveLanguage == null) return null;

  return (
    <div className={styles.root}>
      <div className={styles.label}>
        <TranslateIcon size={11} language={effectiveLanguage} />
        &nbsp;Translation
      </div>
      <div className={styles.editor}>{children(effectiveLanguage)}</div>
    </div>
  );
}
